import React, { useState } from "react";
import axios from "axios";
import API_BASE_URL from "../../config/config.js";
import Select from "react-select";
import Button from "@mui/joy/Button";
import Add from "@mui/icons-material/Add";

// toast
import { toast } from "react-hot-toast";

// modal
import ModalAreaSelect from "../../components/Modals/ModalAreaSelect/ModalAreaSelect.jsx";

const CreateSport = ({ eventos, deportes }) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedSport, setSelectedSport] = useState(null);
  const [selectedSportIndex, setSelectedSportIndex] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null); // Evento seleccionado

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleClick = async (deporte, index) => {
    if (deporte === selectedSport && index === selectedSportIndex) {
      setSelectedSportIndex(null);
      setSelectedSport(null);
    } else {
      setSelectedSportIndex(index);
      setSelectedSport(deporte);
    }
  };

  const handleSave = async () => {
    if (!selectedEvent || !selectedSport) {
      toast.error("Debe seleccionar un evento y un deporte.");
      return;
    }

    const idsPermitidosFut = [6, 7, 5, 42];

    try {
      await axios.post(`${API_BASE_URL}/categoria`, {
        idevent: selectedEvent.value,
        idsport: selectedSport.idsport,
      });

      await axios.post(`${API_BASE_URL}/postconfigcategory`, {
        idevent: selectedEvent.value,
        idsport: selectedSport.idsport,
      });

      if (idsPermitidosFut.includes(selectedSport.idsport)) {
        await axios.post(`${API_BASE_URL}/postconfigtarjetas`, {
          idevent: selectedEvent.value,
          idsport: selectedSport.idsport,
        });
      }

      setOpenModal(false);
      toast.success("¡Categoria Creada Exitosamente!");
    } catch (error) {
      console.error("Error en crear una categoria", error);
      toast.error("¡Hubo un Problema al Crear la Categoria!");
    }
  };

  return (
    <>
      <div className="bg-white p-5 rounded-2xl dark:bg-gray-600 dark:text-gray-300 flex-1">
        <div>
          <h5 className="mb-2 text-2xl font-medium font-bold text-gray-700 dark:text-neutral-50">
            Agregar Deporte
          </h5>
        </div>
        <div className="mb-4">
          <Select
            options={eventos.map((evento) => ({
              value: evento.idchampionship,
              label: evento.name,
            }))}
            value={selectedEvent}
            onChange={(option) => setSelectedEvent(option)}
            placeholder="Selecciona un evento"
            isSearchable
            className="w-full"
          />
        </div>
        <div>
          <Button startDecorator={<Add />} onClick={handleOpenModal}>
            Añadir Deporte
          </Button>
        </div>
      </div>
      <ModalAreaSelect
        elementos={deportes}
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleSaveElemento={handleSave}
        handleClick={handleClick}
        selectedIndex={selectedSportIndex}
        titulo="Deporte"
      />
    </>
  );
};

export default CreateSport;
